export const DROPDOWN_EMPTY_MESSAGE = 'Unavailable data';
export const SUPPLIER_TYPES = {
  SUPPLIER: 'Supplier',
  PAYEE: 'Payee',
};
export const DEFAULT_EMPTY_VALUE = '--';
export const DEFAULT_CURRENCY = {
  value: 1,
  id: 'PHP',
  label: 'PHP - Philippine Peso',
  currencySign: 'PHP ',
};

const ACCOUNT_PERIOD_CLOSED_ERROR = {
  title: 'Account Period Closed',
  message:
    'The account period has closed and the account books cannot be updated through the QBO services API. Please use the QBO website to make these changes',
};

const MAX_SIZE_MB = 20;
const FILE_SIZE_ERROR = {
  title: `File is more than ${MAX_SIZE_MB} MB`,
  message: `The size of your file exceeds ${MAX_SIZE_MB} MB. You are unable to create a transaction at this time`,
};

export const MESSAGE_ERRORS = {
  'File size exceeds the 20 MB limit.': FILE_SIZE_ERROR,
};

export const DEFAULT_PUBLISH_ERROR = {
  title: 'Publishing Failed',
  message: `Publishing failed for unknown reason. Please try again`,
};

export const QB_ERRORS = {
  // 6140: {
  //     code: 6140,
  //     title: 'Duplicate Number',
  //     message: 'This number has already been used. Are you sure you want to continue publishing?'
  // },
  6200: {
    code: 6200,
    ...ACCOUNT_PERIOD_CLOSED_ERROR,
  },
  6210: {
    code: 6210,
    ...ACCOUNT_PERIOD_CLOSED_ERROR,
  },
  2500: {
    code: 2500,
    title: 'Invalid Account Type',
    message: "Something you're trying to use has been made inactive. Check the field with accounts",
  },
};
